import { Box } from '@palmetto/palmetto-components';

interface SimpleFlaggedSectionBoxProps {
  label: string;
}

export const SimpleFlaggedSectionBox = ({ label }: SimpleFlaggedSectionBoxProps) => {
  return (
    <Box background="primary" borderColor="separator" borderWidth="xs" radius="md" padding="md" margin="0 0 md 0">
      <Box fontSize="md" fontWeight="medium">
        {label}
      </Box>
    </Box>
  );
};
